/*
    Developer Name : Raja :)
    Developed Date : 25-03-2022
    Page Name      : NumberToWords
    Last Edited By : 
    Edited Date    : 
    Last Edited    : implemented number to words
*/

import { Pipe, PipeTransform } from '@angular/core';
import { ToWords } from 'to-words';

@Pipe({ name: 'numberToWords' })
export class NumberToWordsPipe implements PipeTransform { 
    toWords = new ToWords({
        localeCode: 'en-IN',
        converterOptions: {
          currency: false,
          ignoreDecimal: false,
          ignoreZeroCurrency: false,
          doNotAddOnly: false,
        }
    });
    transform(input: any): string {
        return !!input?this.toWords.convert(input):'';
    }
}
